<div>
    <div class="menuItem" [style.z-index]="zindex()" (click)="openSubmenuList($event)">
        <span multilang [defaultlanguage]="partner?.defaultLanguage || 'de'">{{data()?.title}}</span>
        <mat-icon *ngIf="data()?.list?.length > 0" class="cc1">keyboard_arrow_right</mat-icon>
    </div>
    <mat-divider></mat-divider>
</div>